import { ALLIANCEMESSAGEKEY } from "../variables";
export default function getAllianceMessage(provider, includeKey = true) {
  const promotor = provider?.split(":")?.[2] || "";
  return (
    (includeKey ? `${ALLIANCEMESSAGEKEY}: ` : "") +
    (promotor.trim() !== "" ? `${promotor}` : "Agencia externa")
  );
}
